const messagesConstants = {
  GET_MESSAGES: 'GET_MESSAGES',
  GET_MESSAGES_SUCCESS: 'GET_MESSAGES_SUCCESS',
  GET_MESSAGES_FAILURE: 'GET_MESSAGES_FAILURE',

  SET_DIRECT_MESSAGES_FILTER: 'SET_DIRECT_MESSAGES_FILTER',
};

export default messagesConstants;
